<div class="approved-payment">
    <div class="panel text-center">
        <div class="row">
            <div class="col-12 col-sm-12">
                <h4>THANK YOU FOR YOUR PAYMENT OF {{userOrderStatusDto.total | currency : userOrderStatusDto.currencyCode : userOrderStatusDto.currencyCode + " "}}!</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <h5>Order Number: {{orderNumber}}</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <p style="font-weight:500">You are registered for the <span [ngClass]="testTypeCssClass">{{testSessionInformation.testTypeDisplayName}} Test</span>.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <p style="font-weight:500">{{testDate | customDate: 'selectedTestFormatDateTime'}}</p>
                <br *ngIf=testSessionInformation.isWebDelivery />
                <span *ngIf="testSessionInformation.isWebDelivery">(Time Zone: {{localTimeZone}})</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <strong>{{testSessionInformation.testCentreName}}</strong><br />
                <ng-container *ngIf="!testSessionInformation.isWebDelivery">
                    <ng-container *ngIf="testSessionInformation.testCentreAddressLine2 && testSessionInformation.testCentreAddressLine2.length > 0">{{testSessionInformation.testCentreAddressLine2}} - </ng-container>{{testSessionInformation.testCentreAddressLine1}}<br />
                    {{testSessionInformation.testCentreCity}}, {{testSessionInformation.testCentreRegion}} <span *ngIf="testSessionInformation.testCentrePostalCode.length > 0">{{testSessionInformation.testCentrePostalCode}}</span><br />
                    {{testCentreCountry}}<br />
                </ng-container>
            </div>
        </div>
        <div
            class="row"
            *ngIf="!testSessionInformation.isWebDelivery"
            style="text-align: center;"
        >
            <div
                class="col-12 col-sm-12"
                style="display: inline-block"
            >
                <a
                    href="http://maps.google.com?q={{testSessionInformation.testCentreAddressLine1 + testSessionInformation.testCentreAddressLine2 + testSessionInformation.testCentreAddressLine3 + testSessionInformation.testCentreCity}}"
                    class="link"
                    target="_blank"
                >View directions</a>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-12 col-sm-12">
                <p>Your confirmation email and invoice will be emailed to <strong>({{ userEmail$ | async }})</strong> shortly. <strong>Please make sure to check your junk/spam folder.</strong></p>
            </div>
        </div>
        <br />
        <div class="download-icon">
            <i class="fa fa-download fa-4x"></i>
            <br />
            <a
                class="btn btn-primary my-3"
                (click)="showTestConfirmationEmail()"
            >Download test confirmation email</a>
        </div>
    </div>
    <div class="text-center">
        <h4 class="text-uppercase">
            what you will need on the test day:
        </h4>
        <ul>
            <li><strong>Test Confirmation email (Electronic or printed hardcopy)</strong></li>
            <li>
                <strong class="required-document">Identification document</strong>
                <br />
                <br />
                <div>
                    <p class="highlight">
                        IMPORTANT: Test takers who do not bring an acceptable identity document will be refused entry and will not be eligible for a refund or test transfer accommodation.
                    </p>
                    <h5>IDENTIFICATION DOCUMENT NEEDS TO BE:</h5>
                    <ul>
                        <li>Valid</li>
                        <li>Unexpired</li>
                        <li>Original (Photocopies are unacceptable)</li>
                    </ul>
                </div>
            </li>
        </ul>
        <p class="font-italic">Only your identification document will be allowed in the test room. Personal belongings will be stored securely at check-in.
        </p>
        <br />
        <h4 class="text-uppercase">
            how to prepeare for your {{brandName}} test:
        </h4>
        <ul>
            <li>
                <a
                    href={{prepareForTestUrl}}
                    target="_blank"
                ><strong>Sample practice tests and workshops</strong></a></li>
            <li><a
                    [routerLink]="['/product-shopping']"
                    class="font-weight-bold"
                ><strong>Online study materials</strong></a></li>
        </ul>
        <br />
        <h4 class="text-uppercase">
            Things you can do in your {{brandName}} account:
        </h4>
        <ul>
            <li>Transfer and Cancel the test</li>
            <li>Update your shipping address</li>
            <li>View your order history</li>
        </ul>
        <a
            class="btn btn-primary"
            [routerLink]="['/my-account']"
        >Go to My Account</a>
    </div>
</div>
